export const MAX_CLIPS = 30;
